import React, { Component } from 'react';
import { Row, Col, Button, } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import _ from 'lodash';
import { RowRenderer } from '../../Common/rowRenderer';
import { DateFormatter2 } from '../../Common/dateFormat';
import { isAP } from '../../../actions/root_url'

const ENTER_KEY = 13;

const { Selectors } = Data;

export class NewBatchModal extends Component {
    constructor() {
        super();
        this.state = {
            quantityRemaining: 0,
            changed: false,
            oldLoaded: 0,
            batches: {
                rows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
                editedRows: [],
            },
            selectBatches: [],
            isNonFixed: false,
            weights: [],
            currentSelectBatchIndex: -1,
            currentWtIndex: 0,
            currentWt: '',
            currentTotalWt: '',
        }
    }

    componentDidMount() {
        if (isAP) {
            this.props.fetchBatches();
        }
    }

    componentWillUnmount() {
        if (!this.state.changed) {
            this.props.keepLoaded(this.props.oldLoaded || this.state.oldLoaded);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (isAP && nextProps.batchesInfo !== this.props.batchesInfo && nextProps.batchesInfo.batches.length) {
            this.initializeModal(nextProps.batchesInfo.batches)
        }
    }

    initializeModal = (batchesInfo = []) => {
        const { selectedRow, quantityValue, oldLoaded } = this.props;
        const rowBatches = ((selectedRow || { Batches: [] }).Batches || []).map((bat, index) => ({ ...bat, index, batchId: bat.Batch_id_id })) || [];
        let quantityRemaining = Number(this.props.quantityValue || 0);
        let index = 0;
        let batchesRows = batchesInfo.map(r => {
            let rowIndex = rowBatches.findIndex(bat => bat.batchId == r.id);
            if (rowIndex != -1 && quantityRemaining >= rowBatches[rowIndex].BatchQty) {
                quantityRemaining -= rowBatches[rowIndex].BatchQty;
                return {
                    Idx: index++,
                    batchId: r.id,
                    quantity: rowBatches[rowIndex].BatchQty,
                    expire_datetime: r.expire_datetime,
                    location: r.location,
                    batch_num: r.batch_num,
                    availableQty: r.quantity,
                    is_initial_batch: r.is_initial_batch,
                };
            }
            return {
                Idx: index++,
                batchId: r.id,
                quantity: 0,
                expire_datetime: r.expire_datetime,
                location: r.location,
                batch_num: r.batch_num,
                availableQty: r.quantity,
                is_initial_batch: r.is_initial_batch,
            };
        })

        const batches = {
            ...this.state.batches,
            rows: batchesRows,
        }
        this.setState({
            batches,
            quantityRemaining,
            selectBatches: rowBatches,
            isNonFixed: selectedRow.ProductType == 'Non-Fixed',
        });
    }

    _handleKeyDown = (event) => {
        switch (event.keyCode) {
            case ENTER_KEY:
                this.handleOnSubmit();
                break;
            default:
                break;
        }
    }
    handleOnSubmit = (e) => {
        let totalWeight = 0;
        const batchRows = [];
        let sumQty = 0;
        this.state.selectBatches.map((row) => {
            sumQty += Number(row.BatchQty);
            let weights = [];
            if (this.state.isNonFixed) {
                weights = row.weights.map(wt => wt.weight);
            }
            let lineWt = weights.reduce((a, b) => a + Number(b || 0), 0)
            batchRows.push({
                Batch_id_id: row.batchId,
                BatchExpiredDate: row.expire_datetime,
                BatchLocation: row.location,
                BatchQty: row.BatchQty,
                BatchWeight: lineWt,
                BatchNum: row.BatchNum,
                weights: weights
            });

            totalWeight += lineWt;
        });

        if (sumQty < Number(this.props.quantityValue)) {
            alert('Qty is less than your loaded Qty.');
            return
        }
        if (totalWeight <= 0) {
            alert('Weight cannot be empty.');
            return
        }
        this.props.returnBatch(totalWeight.toFixed(2), batchRows);
        this.setState({ changed: true }, () => { this.props.close(); });
    };

    handleNoBatToSelectedTable = () => {
        let qty = Number(this.props.quantityValue || 0);
        let bat = { BatchQty: qty, index: 0 };
        let weights = [];
        for (let i = 0; i < qty; i++) {
            weights.push({ weight: 0, Idx: i });
        }
        if (this.state.isNonFixed) {
            bat.weights = weights;
        }
        this.setState({
            weights: [],
            currentWtIndex: 0,
            currentSelectBatchIndex: -1,
            selectBatches: [bat],
        });
    }

    handleToSelectedTable = () => {
        const { batches, selectBatches, isNonFixed } = this.state;
        // 选择批次
        let sltBatches = [];
        batches.rows.filter(bat => bat.quantity > 0).map(batch => {
            if (!isNonFixed) {
                sltBatches.push({ ...batch, BatchNum: batch.batch_num, BatchQty: batch.quantity });
            }
            let weights = [];
            let havIndex = selectBatches.findIndex(bat => bat.batchId && bat.batchId == batch.batchId && batch.quantity == bat.BatchQty);
            if (havIndex != -1) {
                weights = selectBatches[havIndex].weights;
            } else {
                for (let i = 0; i < batch.quantity; i++) {
                    weights.push({ weight: 0, Idx: i });
                }
            }
            sltBatches.push({ ...batch, weights, BatchNum: batch.batch_num, BatchQty: batch.quantity });
        });
        let oldBatches = selectBatches.filter(bat => bat.batchId && sltBatches.findIndex(batch => batch.batchId == bat.batchId) == -1);
        this.setState({
            weights: [],
            currentWtIndex: 0,
            currentSelectBatchIndex: -1,
            selectBatches: [...sltBatches, ...oldBatches].map((bat, index) => ({ ...bat, index })),
        });
    }

    handleToWeightTable = (row) => {
        // 填写重量
        let wts = this.state.isNonFixed ? row.weights.map(wt => ({ ...wt, weight: wt.weight + '' })) : [];
        this.setState({ currentSelectBatchIndex: row.index, weights: wts, currentWtIndex: 0 });
    }

    handleSetCurrentWt = (e) => {
        this.setState({ currentWt: e.target.value });
    }
    handleSetTotalCurrentWt = (e) => {
        this.setState({ currentTotalWt: e.target.value });
    }

    divideAndExtractRemainder = (a, b) => {
        // 计算结果 c 并保留两位小数
        let c = (a / b).toFixed(2);
        let cNumber = parseFloat(c);
        let remainder = a - (cNumber * b).toFixed(2);
        return {
            result: cNumber,
            lastResult: cNumber + remainder,
        };
    }
    handleOnkeyDownSetWt = (e, isTotal = false) => {
        if (e.keyCode == ENTER_KEY && e.key == 'Enter') {
            const { weights, currentWtIndex, currentSelectBatchIndex, selectBatches } = this.state;
            if (!weights.length || currentSelectBatchIndex == -1) {
                return
            }
            let cpWts = _.cloneDeep(weights);
            let sltBatches = [...selectBatches];
            if (isTotal) {
                let wtInfo = e.target.value ? this.divideAndExtractRemainder(e.target.value, weights.length) : { result: 0, lastResult: 0 };
                let wtRow = weights.map((wt, index) => {
                    if (index == weights.length - 1) {
                        return { weight: wtInfo.lastResult + '', Idx: index };
                    }
                    return { weight: wtInfo.result + '', Idx: index };
                })
                sltBatches[currentSelectBatchIndex].weights = wtRow;
                this.setState({
                    currentTotalWt: '',
                    weights: wtRow,
                    selectBatches: sltBatches,
                });
            } else {
                let index = currentWtIndex < weights.length - 1 ? currentWtIndex + 1 : 0;
                cpWts[currentWtIndex].weight = e.target.value ? parseFloat(e.target.value) + '' : '';
                sltBatches[currentSelectBatchIndex].weights = cpWts;
                this.setState({
                    weights: cpWts,
                    selectBatches: sltBatches,
                    currentWt: '',
                    currentWtIndex: index,
                });
            }
        }
    }

    renderBatchesTable() {
        const getRows = () => {
            return Selectors.getRows(this.state.batches);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        const handleRowUpdated = e => {
            const rows = getRows();
            Object.assign(rows[e.rowIdx], e.updated);
            this.setState({ batches: { ...this.state.batches, rows } });
        }

        const handleFilterChange = (filter) => {
            const newFilters = Object.assign({}, this.state.batches.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            const batches = { ...this.state.batches, filters: newFilters }
            this.setState({ batches });
        };

        const onClearFilters = () => {
            const batches = { ...this.state.batches, filters: {} }
            this.setState({ batches });
        };

        const handleGridSort = (sortColumn, sortDirection) => {
            const batches = { ...this.state.batches, sortColumn, sortDirection };
            this.setState({ batches });
        };

        const columns = [
            {
                key: 'quantity',
                name: <Translate value="quantity" />,
                resizable: true,
                sortable: true,
                filterable: true,
                editable: true,
                width: 90,
            },
            {
                key: 'availableQty',
                name: <Translate value="available" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 90,
            },
            {
                key: 'expire_datetime',
                name: <Translate value="expired" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 120,
                formatter: DateFormatter2,
            },
            {
                key: 'location',
                name: <Translate value="location" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 110,
            },
            {
                key: 'batch_num',
                name: <Translate value="batch_num" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 120,
            },
        ]

        return (
            <Row>
                <label style={{ color: 'orange', fontSize: '15px' }}><Translate value="quantity_remaining" />: {this.state.quantityRemaining}</label>
                <Col>
                    <div style={{ maxWidth: '850px', marginLeft: '10px' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <Button
                                bsStyle="success"
                                onClick={this.handleToSelectedTable}
                                style={{ float: 'right' }}
                            >
                                <Translate value='add_batches' />
                            </Button>
                            <Button
                                bsStyle="success"
                                onClick={this.handleNoBatToSelectedTable}
                                style={{ float: 'right' }}
                            >
                                <Translate value='add' />
                            </Button>
                        </div>
                        <ReactDataGrid
                            enableCellSelect={true}
                            rowRenderer={
                                <RowRenderer />
                            }
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={300}
                            rowHeight={25}
                            headerRowHeight={45}
                            onRowUpdated={handleRowUpdated}
                            toolbar={<Toolbar enableFilter />}
                            onAddFilter={handleFilterChange}
                            onClearFilters={onClearFilters}
                            onGridSort={handleGridSort}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    renderSelectedBatchesTable() {
        const getRows = () => {
            return this.state.selectBatches;
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        const handleGridSort = (sortColumn, sortDirection) => {
            const batches = { ...this.state.batches, sortColumn, sortDirection };
            this.setState({ batches });
        };

        const columns = [
            {
                key: 'BatchNum',
                name: <Translate value="batch_num" />,
                resizable: true,
                sortable: true,
                width: 120,
            },
            {
                key: 'BatchQty',
                name: <Translate value="quantity" />,
                resizable: true,
                sortable: true,
                width: 90,
            },
        ]

        return (
            <Row>
                <Col>
                    <div style={{ maxWidth: '285px', marginLeft: '10px' }}>
                        <ReactDataGrid
                            rowRenderer={
                                <RowRenderer onDoubleClick={(row) => {
                                    this.handleToWeightTable(row);
                                }} />
                            }
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={300}
                            minWidth={210}
                            rowHeight={25}
                            headerRowHeight={45}
                            onGridSort={handleGridSort}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    renderWeightTable() {
        const getSize = () => {
            return this.state.weights.length;
        }
        const rowGetter = rowIdx => {
            return this.state.weights[rowIdx];
        }

        const setCurrentWt = (currentWtIndex) => {
            let wt = this.state.weights[currentWtIndex].weight
            this.setState({ currentWtIndex, currentWt: wt });
        }

        const columns = [
            {
                key: 'Idx',
                name: <Translate value="idx" />,
                resizable: true,
                width: 40,
                formatter: ({ value }) => {
                    return <div>{(value + 1)}</div>
                }
            },
            {
                key: 'weight',
                name: <Translate value="weight" />,
                resizable: true,
                filterable: true,
                width: 80,
            },
        ]

        return (
            <Row>
                <Col>
                    <div style={{ maxWidth: '120px', marginLeft: '10px' }}>
                        <ReactDataGrid
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={300}
                            minWidth={120}
                            rowHeight={25}
                            headerRowHeight={45}
                            onRowClick={(index) => {
                                setCurrentWt(index);
                            }}
                            enableCellSelect={true}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    renderSetWeightView() {
        return <div style={styles.wt_root}>
            <div style={styles.wt_tt}>Set WT</div>
            <div style={styles.wt_row}>
                <div style={styles.wt_ind}>{this.state.currentWtIndex + 1}</div>
                <input type='number'
                    value={this.state.currentWt}
                    style={styles.wt_input}
                    onChange={(e) => {
                        this.handleSetCurrentWt(e);
                    }}
                    onKeyDown={(e) => {
                        this.handleOnkeyDownSetWt(e);
                    }}
                />
            </div>
            <div style={styles.wt_tt}>Total Wt</div>
            <input type='number'
                value={this.state.currentTotalWt}
                style={styles.wt_input_total}
                onChange={(e) => {
                    this.handleSetTotalCurrentWt(e);
                }}
                onKeyDown={(e) => {
                    this.handleOnkeyDownSetWt(e, true);
                }}
            />

        </div>
    }

    render() {
        const { isNonFixed } = this.state;
        return (
            <div>
                <div style={styles.row_container}>
                    <div style={{ width: '50%' }}>
                        {this.renderBatchesTable()}
                    </div>
                    <div style={{ width: isNonFixed ? '20%' : '50%' }}>
                        {this.renderSelectedBatchesTable()}
                    </div>
                    {isNonFixed && <div style={{ width: '15%' }}>
                        {this.renderWeightTable()}
                    </div>}
                    {isNonFixed && <div style={{ width: '15%' }}>
                        {this.renderSetWeightView()}
                    </div>}
                </div>
                <div style={styles.bot_v}>
                    <Button
                        bsStyle="danger"
                        onClick={this.props.close}
                        style={{ float: 'right' }}
                    >
                        <Translate value='cancel' />
                    </Button>
                    <Button
                        bsStyle="primary"
                        onClick={this.handleOnSubmit}
                        style={{ float: 'right', marginLeft: 50 }}
                    >
                        <Translate value='confirm' />
                    </Button>
                </div>
            </div>
        );
    }
}

export default NewBatchModal;

const styles = {
    row_container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'end',
    },
    wt_root: {
        display: 'flex',
        width: '100%',
        height: '300px',
        flexDirection: 'column'
    },
    wt_row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    wt_ind: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '26px',
        width: '40px',
        border: 'solid',
        borderWidth: '1px',
    },
    wt_tt: {
        fontSize: 'medium',
        fontWeight: '600',
    },
    wt_input: {
        height: '26px',
        width: '80px',
        border: 'solid',
        borderWidth: '1px',
        borderLeft: 'none',
        paddingLeft: '4px',
    },
    wt_input_total: {
        height: '26px',
        width: '120px',
        border: 'solid',
        borderWidth: '1px',
        paddingLeft: '4px',
    },
    bot_v: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: '10px',
        alignItems: 'center'
    },
}



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/NewBatchModal.jsx